var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTranslate } from 'react-admin';
import { Tooltip, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
export var CancelEditButton = function (_a) {
    var cancel = _a.cancel, props = __rest(_a, ["cancel"]);
    var translate = useTranslate();
    return (React.createElement(Tooltip, { title: translate('ra.action.cancel', {
            _: 'ra.action.cancel',
        }) },
        React.createElement(IconButton, __assign({ onClick: cancel, size: "small" }, props),
            React.createElement(CancelIcon, null))));
};
export default CancelEditButton;
